<h1 mat-dialog-title>Print</h1>
<div mat-dialog-content fxLayout="column">
  todo
</div>
<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()">Cancel</button>
  <button mat-button (click)="submitDialog()" cdkFocusInitial [disabled]="true">Save</button>
</div>
